import { render } from "./UsersNew.vue?vue&type=template&id=26b0aac4"
import script from "./UsersNew.vue?vue&type=script&lang=js"
export * from "./UsersNew.vue?vue&type=script&lang=js"
script.render = render

export default script